"use client"

import * as React from "react"
import { KeyMetrics } from "@/components/key-metrics"
import { EVAL_DASHBOARD_KPI_STRIP_CLASS } from "@/lib/evaluation-dashboard-a11y"
import {
  QUALITY_HEALTH,
  evaluationQualityHealthMetrics,
} from "@/lib/mock/evaluation-quality-dashboard"

export function QualityHealthHero() {
  const metrics = React.useMemo(
    () => evaluationQualityHealthMetrics(QUALITY_HEALTH),
    [],
  )

  return (
    <section aria-labelledby="quality-health-heading">
      <h2 id="quality-health-heading" className="sr-only">
        Education quality health
      </h2>
      <KeyMetrics
        variant="cards"
        size="md"
        metrics={metrics}
        showHeader={false}
        metricsSingleRow
        className={EVAL_DASHBOARD_KPI_STRIP_CLASS}
      />
    </section>
  )
}
